import { FileTypes } from '@/constants';
import dayjs from 'dayjs';

export const exportExtensionFile = (data: Blob, name: string, type?: FileTypes) => {
  const url = window.URL.createObjectURL(
    new Blob([data], {
      type: type || FileTypes.XLSX,
    }),
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const getExportFileName = (name: string, startDate?: Date, endDate?: Date) => {
  const formattedFileName = name.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-');
  const formattedDate = `_[${dayjs(startDate).format('MMM DD, YYYY')}]-[${dayjs(endDate).format('MMM DD, YYYY')}]`;
  return `${formattedFileName}${startDate && endDate ? formattedDate : ''}`;
};

export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        // Remove the Data URL prefix (e.g., "data:image/jpeg;base64,")
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      } else {
        reject(new Error('Failed to convert file to base64'));
      }
    };
    reader.onerror = (error) => reject(error);
  });
};
